<template>
  <div class="relative flex flex-wrap items-stretch border-[1px] border-[#E2E2E2] rounded-[6px] overflow-hidden">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step-item relative flex flex-wrap items-center justify-start gap-[16px] grow px-[24px] py-[16px] after:hidden sm:after:block before:hidden sm:before:block last:after:hidden last:before:hidden"
    >
      <div
        class="text-medium rounded-full size-[40px] border-[2px] flex items-center justify-center"
        :class="[
          isCurrentStep(index) ? 'border-[#F95031] text-[#F95031]' : 'border-[#E2E2E2] text-[#333333]',
          isBeenThere(index) ? 'bg-[#F95031] text-white' : ''
        ]"
      >
        <check-icon
          v-if="isBeenThere(index)"
          size="1.5x"
        />
        <span v-else>
          {{ formatNumber(index + 1) }}
        </span>
      </div>
      <div class="[&>p]:mb-0 text-[14px] [&>p]:text-[14px]">
        <p
          class="font-medium"
          :class="[
            isCurrentStep(index) ? 'text-[#F95031]' : 'text-[#333333]',
          ]"
        >
          {{ step.label }}
        </p>
        <p class="text-[#626262]">
          {{ step.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckIcon } from 'vue-feather-icons'

export default {
  components: {
    CheckIcon,
  },
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      steps: [
        {
          label: 'Campaign Setup',
          description: 'Isi detail campaign',
        },
        {
          label: 'Preview & Creator',
          description: 'Preview & Creator',
        },
      ],
    }
  },
  methods: {
    formatNumber(value) {
      return value < 10 ? `0${value}` : value
    },
    isCurrentStep(index) {
      return index <= this.currentStep
    },
    isBeenThere(index) {
      return index < this.currentStep
    },
  },
}
</script>

<style scoped>
.step-item {
  position: relative;
}
.step-item:not(:last-child)::before, .step-item:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 15px;
  height: 50%;
  width: 1px;
  border-right: 1px solid #E2E2E2;
  z-index: 1;
}
.step-item:not(:last-child)::before {
  transform: skewX(20deg);
  transform-origin: top right;
  top: 0;
}
.step-item:not(:last-child)::after {
  transform: skewX(-20deg);
  transform-origin: bottom right;
  bottom: 0;
}
</style>
